// Colour of the small dot shown next to a task's contact, keyed by the
// channel of the conversation the task came from. Mirrors the per-channel
// palette of the CrmB mockup, mapped onto theme-aware n-* tokens.
const CHANNEL_DOT = {
  'Channel::Whatsapp': 'bg-n-teal-9',
  'Channel::TwilioSms': 'bg-n-teal-9',
  'Channel::Sms': 'bg-n-teal-9',
  'Channel::Instagram': 'bg-n-ruby-9',
  'Channel::Email': 'bg-n-blue-9',
  'Channel::FacebookPage': 'bg-n-iris-9',
  'Channel::WebWidget': 'bg-n-amber-9',
};

export const channelDotClass = channelType =>
  CHANNEL_DOT[channelType] || 'bg-n-slate-8';
